import { useAuth0 } from '@auth0/auth0-react';
import { AlertCircle, LogIn } from 'lucide-react';

interface SessionExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SessionExpiredModal({ isOpen, onClose }: SessionExpiredModalProps) {
  const { loginWithRedirect } = useAuth0();

  if (!isOpen) return null;

  const handleLogin = () => {
    loginWithRedirect({
      appState: {
        returnTo: window.location.pathname,
      },
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-dark-800 border border-dark-700 rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center">
            <AlertCircle className="w-5 h-5 text-red-500" />
          </div>
          <h2 className="text-xl font-semibold text-dark-100">Sesión Expirada</h2>
        </div>

        <p className="text-dark-300 mb-6">
          Tu sesión ha expirado por seguridad. Por favor, inicia sesión nuevamente para continuar.
        </p>

        <div className="flex gap-3">
          <button
            onClick={handleLogin}
            className="flex-1 flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-medium py-2.5 px-4 rounded-lg transition-colors"
          >
            <LogIn className="w-4 h-4" />
            Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  );
}
